import { BaseComponent, StoryblokImage } from '@cinch-nx/data-storyblok'
import styles from './hero.module.css'
import cx from 'classnames'
import { Hero as GenericHero } from '@cinch-nx/landing-ui-shared'

export interface HeroProps extends BaseComponent {
  component: 'GenericHero'
  title: string
  image: StoryblokImage
  body: string
}

export const Hero = (props: HeroProps) => (
  <section className={styles.container} aria-describedby="hero-heading">
    <div className={cx(styles.background, styles.backgroundGradient)}>
      <div className={styles.heroInner}>
        <div className={styles.textAndImageContainer}>
          <GenericHero heroProps={props} />
        </div>
      </div>
    </div>
  </section>
)
